export class Pais {
	codigo: string;
	abrev: string;
	descripcion: string;
	iso3166a3: string;
	iso3166numerico: number;
	activo: boolean;
	id: number;

	constructor(data = null) {
		if (data) {
			this.abrev = data.abrev;
			this.codigo = data.codigo;
			this.descripcion = data.descripcion;
			this.iso3166a3 = data.iso3166a3;
			this.iso3166numerico = data.iso3166numerico;
			this.activo = data.activo;
			this.id = data.id;
		}
	}
}
